<template lang="pug">
modal#create-team-modal(
  :loading='loading'
  :process-button-label='$t("modal.createTeam.processButtonLabel")'
  :showCancelButton='false'
  :title='$t("modal.createTeam.title")'
  @closed='onCloseModal'
  @process='submit'
  ref='modal'
  size='sm'
)
  ValidationObserver(ref='form' v-slot='{ handleSubmit }')
    form(@submit.prevent='handleSubmit(submit)')

    ValidationProvider(
      name='nome'
      rules='required'
      v-slot='{ errors }'
    )
      .form-group
        label {{ $t('modal.createTeam.nameLabel') }}
        .form-control-icon
          icon(name='users')
          input.form-control(
            :class='{ "border border-danger": errors[0] }'
            :placeholder='$t("modal.createTeam.namePlaceholder")'
            autocomplete='off'
            type='text'
            v-model.trim='team.name'
          )
        small.text.text-danger {{ errors[0] }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import '@/services/Validator';
import Icon from '@/ui/atoms/Icon.vue';
import formHandler from '@/modules/account/common/formHandler';
import TeamsService from '@/modules/account/services/http/TeamsService';

export default {
  name: 'CreateTeamModal',
  components: {
    Modal,
    Icon,
  },
  data() {
    return {
      loading: false,
      team: {
        name: '',
      },
    };
  },

  methods: {
    cleanInputTeam() {
      this.team = {
        name: '',
      };
      this.$nextTick(() => {
        this.$refs.form.reset();
      });
    },

    async submit() {
      formHandler.submit(this, () => TeamsService.create(this.team), {
        fieldsByPropertyName: {
          name: 'nome',
        },
        successHandler: (response) => {
          formHandler.defaultSuccess(response);
          this.cleanInputTeam();
          this.$refs.modal.close();
          this.$emit('refresh');
        },
      });
    },

    onCloseModal() {
      this.cleanInputTeam();
    },
  },
};
</script>
